import { Stack } from "@mantine/core";
import { Tenant } from "src/graphql/generated/graphql";

import { SEOAnalytics } from "./analytics";

export interface SEOTabProps {
    tenant: Tenant;
    onTenantUpdate?();
}

export const SEOTab = ({ tenant, onTenantUpdate }: SEOTabProps) => {
    return (
        <Stack spacing="md">
            <SEOAnalytics tenant={tenant} onTenantUpdate={onTenantUpdate} />
        </Stack>
    );
};
